import React from 'react';
import { block } from '../utils/cn';
import './UserAvatar.css';
const b = block('user-avatar');
export function UserAvatar({ imgUrl, size = 'm', title, className, onClick }) {
    return (React.createElement("div", { title: title, className: b({ size }, className), style: {
            backgroundImage: `url(${imgUrl})`,
        }, onClick: onClick }));
}
